import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";
import Hero from "../components/home/Hero";
import EditorialMarquee from "../components/home/EditorialMarquee";
import Services from "../components/home/Services";
import Stats from "../components/home/Stats";
import WhyUs from "../components/home/WhyUs";
import Manifesto from "../components/home/Manifesto";
import Process from "../components/home/Process";
import Reviews from "../components/home/Reviews";
import FAQ from "../components/home/FAQ";
import ContactSection from "../components/home/ContactSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Navbar />
      <FloatingActions />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Stats />
        <WhyUs />
        <Process />
        <Manifesto />
        <Reviews />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
